module.exports = "<div class=\"header-strip clearfix\">\n  <div class=\"row\">\n    <div class=\"col-sm-6\">\n      <h4>Export From CSV</h4>\n    </div>\n  </div>\n</div>\n\n<div class=\"card\">\n  <div class=\"card-block\">\n    <div class=\"clearfix\"></div>\n    <div class=\"csv-input\">\n      <input\n        type=\"file\"\n        name=\"csv_exporter\"\n        (change)=\"handleFileInput($event.target.files)\"\n      />\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/extras/export-csv/export-csv.component.html
// module id = ../../../../../src/app/extras/export-csv/export-csv.component.html
// module chunks = main